<template>
  <a-menu mode="inline"
          class="ii-second-console-menu"
          :selected-keys="treeState.selectedKeys"
          :open-keys="treeState.openKeys"
          :class="collapsed ? 'ii-console-menu-collapsed' : ''"
          :inline-collapsed="collapsed"
          @select="onSelect"
          @openChange="onOpenChange">
    <template v-for="item in menus">
      <a-menu-item v-if="!item.children || item.children.length <= 0"
                   :key="item.id">
        <router-link v-if="item.linkTo"
                     :to="item.linkTo"
                     class="menu">
          <auto-icon :type="item.icon || 'folder'" />
          <span class="ii-menu-item">{{ item.name }}</span>
        </router-link>
        <div v-else>
          <auto-icon :type="item.icon || 'folder'" />
          <span>{{ item.name }}</span>
        </div>
      </a-menu-item>
      <sub-menu v-else
                :key="item.id + 'else'"
                :menus="item"
                :collapsed="collapsed" />
    </template>
  </a-menu>
</template>

<script setup lang="ts">
import { useRbacStore, type ConsolePageOption, type ConsolePageService, type Plugin } from "@/plugins"
import { PLUGIN_CONSOLE_PAGE } from "@/plugins/builtin/BuiltinPluginSymbol"
import { AutoIcon } from "@iota-cn/ui-components"
import { container } from "tsyringe"
import { computed, onMounted, reactive, ref, watch } from "vue"
import { useRoute } from "vue-router"
import SubMenu from "./SubMenu.vue"
const plugin = container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(PLUGIN_CONSOLE_PAGE)

const collapsed = plugin.service.isCollapsed()
const treeState = reactive({
  openKeys: [] as string[],
  selectedKeys: [] as string[]
})
const route = useRoute()
const rbacStore = useRbacStore()

onMounted(() => {
  rbacStore.fetchMenus().then(updateMenuState)
})

const updateMenuState = (): void => {
  const path = route.path
  if (path !== "") {
    const { idMap, pathMap } = rbacStore.menus
    const menu = pathMap[path]
    if (menu) {
      const keys = [menu.id]
      let parent = idMap[menu.parentId || ""]
      while (parent && parent.id) {
        //
        keys.push(parent.id)
        parent = idMap[parent.parentId || ""]
      }

      treeState.openKeys = treeState.selectedKeys = keys
      if (collapsed.value) {
        treeState.openKeys = []
      }
    }
  }
}

const onSelect = ({ selectedKeys: keys }: { selectedKeys: any }): void => {
  treeState.selectedKeys = keys
}

const onOpenChange = (keys: any[]): void => {
  treeState.openKeys = keys
}

const menus = computed(() => {
  const tree = rbacStore.menus.tree
  return tree[0] ? tree[0].children : []
})

watch(() => route.path, updateMenuState)
</script>

<style lang="less">
.ii-second-console-menu {
  width: 85% !important;
  margin-top: 15px !important;
  border: none !important;
  overflow: auto;

  .ant-menu-submenu-selected {
    color: #111111;
    font-family: 'Microsoft YaHei';
  }

  .ant-menu-submenu-active:hover {
    color: #111111 !important;
  }

  .ant-menu-submenu-arrow {
    color: #cccccc !important;
  }

  .ant-menu-submenu-open {
    .ii-menu {
      font-family: 'Microsoft YaHei Bold';
    }
  }

  .ant-menu-item-active {
    color: #111111 !important;
  }

  .ant-menu-item {
    font-size: 14px;
  }

  .menu {
    font-size: 16px;
    font-weight: 500;
  }

  &-collapsed {

    >.ant-menu-item .iota-icon,
    .ant-menu-submenu>.ant-menu-submenu-title .iota-icon {
      +span {
        display: inline-block;
        max-width: 0;
        opacity: 0;
      }
    }
  }
}
</style>
>
